import { Button } from "@/components/atoms/buttons";
import ModalTemplate from "@/components/molecules/modal-template";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { PropsWithChildren } from "react";

type EmptyAddressCardProps = {
  locale: Locales;
  modalTitle: string;
  variant?: "address" | "company";
  modalClassName?: string;
};

const EmptyAddressCard = ({
  children,
  locale,
  modalTitle,
  variant = "address",
  modalClassName,
}: PropsWithChildren<EmptyAddressCardProps>) => {
  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-lg bg-[#F4F1F380] py-5">
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="53" height="52" viewBox="0 0 53 52" fill="none">
        <path
          d="M2.35742 29.7132L26.5003 5.57031L50.6431 29.7132"
          stroke="#9C9C9C"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 2"
        />
        <path
          d="M9.78613 22.2852V46.428H43.2147V22.2852"
          stroke="#9C9C9C"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 2"
        />
      </svg>
      <h4 className="text-primary-light leading-h1 text-lg">
        {variant === "address" ? __("No registered address", locale) : __("No company registered", locale)}
      </h4>
      <ModalTemplate
        className={modalClassName}
        classNameTitle="font-cabinet-grotesk leading-h1 text-lg md:text-1xl"
        title={modalTitle}
        triggerAsChild
        modalTrigger={
          <Button
            variant="secondary"
            size="md"
            className="border-primary-light/50 font-cabinet-grotesk bg-inherit font-medium max-sm:h-11"
          >
            {variant === "address" ? __("Add an address", locale) : __("Add company details", locale)}
          </Button>
        }
      >
        {children}
      </ModalTemplate>
    </div>
  );
};

export default EmptyAddressCard;
